<template>
  <b-modal id="deviceTypeCreateModal" size="xl" hide-footer @hidden="resetData">
    <b-row slot="modal-header">
      <b-col>
        <h6>{{$t('views.excmdevicetype.create.title')}}</h6>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <Create :openedInModal="true"></Create>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import Create from '../../Create'
export default {
  name: 'DeviceTypeCreateModal',
  components: {
    Create
  },
  computed: {
    show () {
      return this.$store.state.modals.excmdevicetype.form.show
    },
    close () {
      return this.$store.state.modals.excmdevicetype.form.close
    }
  },
  watch: {
    'show': function (val) {
      this.openModal()
    },
    'close': function (val) {
      if (this.close === 1) {
        this.$store.state.modals.excmdevicetype.form.close = 0
        this.closeModal()
      }
    }
  },
  methods: {
    openModal () {
      if (this.show === 1) {
        this.$store.state.modals.excmdevicetype.form.show = 0
        this.$bvModal.show('deviceTypeCreateModal')
      }
    },
    closeModal () {
      this.$bvModal.hide('deviceTypeCreateModal')
    },
    resetData () {
      // console.log()
    }
  }
}
</script>
